import { render, staticRenderFns } from "./AddExam.vue?vue&type=template&id=15c542c8&scoped=true"
import script from "./AddExam.vue?vue&type=script&lang=js"
export * from "./AddExam.vue?vue&type=script&lang=js"
import style0 from "./AddExam.vue?vue&type=style&index=0&id=15c542c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c542c8",
  null
  
)

export default component.exports